"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: async function () {
        this.state = {
            extensions: [],
            activeCategories: [],
            installing: {},
            uninstalling: {},
            showModal: false,
            search: {},
            suggestions: []
        };
        GState.bind(this, ['marketplace']);
        this.Suggestions = [];
        await this.fetchExtensions();
        this.onContextChange();
        GState.on('marketplace', () => this.onContextChange());
    },
    onContextChange: function () {
        if (typeof this.state.marketplace !== 'object')
            return;
        this.state.marketplace.search && this.setState('search', {
            ...this.state.search,
            ...this.state.marketplace.search
        });
        if (this.state.marketplace.open && (this.state.marketplace.open.name || this.state.marketplace.open.nsi))
            if (!this.state.marketplace.open.id && !this.state.marketplace.open.extensionId) {
                for (let x = 0; x < this.state.extensions.length; x++)
                    if (this.state.extensions[x].name == this.state.marketplace.open.name || this.state.extensions[x].nsi == this.state.marketplace.open.nsi) {
                        this.onOpen(this.state.extensions[x]);
                        break;
                    }
            } else
                this.onOpen(this.state.marketplace.open);
    },
    onRun: function (name) {
        window.Extensions.run(name);
        GState.marketplace.close();
    },
    onOpen: function (dataset) {
        this.state.showModal = {
            type: 'open-app',
            dataset
        };
    },
    onDismiss: function () {
        this.state.showModal = false;
    },
    onSearchQuery: async function (query) {
        this.Suggestions = [];
        this.state.suggestions = [];
        try {
            const {error, message, results} = MPSRequest(`/extension/search?query=${ query }`);
            if (error)
                throw new Error(message);
            results.map(ext => {
                const {favicon, name, description, categories} = ext;
                this.state.suggestions.push({
                    poster: {
                        type: favicon.includes('bx') ? 'icon' : 'image',
                        value: favicon
                    },
                    title: name,
                    subtitle: description
                });
                this.Suggestions.push(ext);
            });
        } catch (error) {
            console.log('Search extensions failed: ', error);
        }
    },
    onCloseSuggestions: function () {
        this.Suggestions = [];
        this.state.suggestions = [];
    },
    onSearchSelect: function (index) {
        this.onOpen(this.Suggestions[index]);
        this.onCloseSuggestions();
    },
    fetchExtensions: async function (limit = 20) {
        try {
            const {error, message, extensions, more} = await window.MPSRequest(this.moreURL || `/extension/list?limit=${ limit }`);
            if (error)
                throw new Error(message);
            this.state.extensions = extensions;
            this.moreURL = more;
        } catch (error) {
            console.log('Failed fetching extension: ', error);
        }
    },
    onInstall: async function (payload) {
        try {
            this.state.installing = {
                nsi: payload.nsi,
                status: 'ONGOING'
            };
            await window.Extensions.install(payload);
            this.state.installing = {
                nsi: payload.nsi,
                status: 'SUCCESS'
            };
        } catch (error) {
            console.log('Installation Failed: ', error);
            this.state.installing = {
                nsi: payload.nsi,
                status: 'FAILED'
            };
        }
    },
    onUninstall: async function (nsi) {
        try {
            this.state.uninstalling = {
                nsi,
                status: 'ONGOING'
            };
            await window.Extensions.uninstall(window.Extensions.meta(nsi).id);
            this.state.uninstalling = {
                nsi,
                status: 'SUCCEED'
            };
        } catch (error) {
            console.log('Uninstallation Failed: ', error);
            this.state.uninstalling = {
                nsi,
                status: 'FAILED'
            };
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_BannerBackground = require("public/images/backgrounds/bg-grey.svg"),
    BannerBackground = module_BannerBackground.default || module_BannerBackground,
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    SearchBar_template = require("../../../components/SearchBar/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Featured_template = require("./components/Featured/index.marko"),
    Featured_tag = marko_loadTag(Featured_template),
    SortingList_template = require("./components/SortingList/index.marko"),
    SortingList_tag = marko_loadTag(SortingList_template),
    Installed_template = require("./components/Installed.marko"),
    Installed_tag = marko_loadTag(Installed_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    ViewApp_template = require("./components/ViewApp/index.marko"),
    ViewApp_tag = marko_loadTag(ViewApp_template),
    Switch_template = require("../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    Modal_template = require("./components/Modal.marko"),
    Modal_tag = marko_loadTag(Modal_template),
    marko_attrs0 = {
        style: "z-index:2000",
        "class": "position-absolute top-0 w-100 theme-bg-primary border-left animated slideInRight"
      },
    marko_attrs1 = {
        "class": "position-sticky zindex-4 top-0 w-100 px-3 py-2"
      },
    marko_attrs2 = {
        style: "height:21rem;",
        "class": "position-relative"
      },
    marko_attrs3 = {
        "class": "h-100 px-3 d-flex align-items-center"
      },
    marko_attrs4 = {
        "class": "w-100 text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("98f208"),
    marko_node0 = marko_createElement("h1", {
        "class": "d-inline-block white-text"
      }, "13", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Multipple Store"),
    marko_attrs5 = {
        "class": "py-1"
      },
    marko_attrs6 = {
        "class": "position-relative"
      };

const Types = ['application', 'plugin', 'website', 'design'];

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.e("div", {
      style: marko_styleValue(("opacity:.3;background:url(\"" + BannerBackground) + "\");background-size:contain"),
      "class": "position-absolute w-100 h-100"
    }, "1", component, 0, 1);

  AutoScroll_tag({
      height: "100vh",
      renderBody: function(out) {
        out.be("section", marko_attrs1, "3", component);

        Row_tag({
            class: "d-flex align-items-center",
            col: [
                {
                    qs: "d-none",
                    hs: "col-2",
                    fs: "col-3"
                  },
                {
                    qs: "col-12",
                    hs: "col-8",
                    fs: "col-6",
                    renderBody: function(out) {
                      SearchBar_tag(marko_assign({}, state.search, {
                          minLength: 2,
                          suggestions: state.suggestions
                        }), out, __component, "7", [
                        [
                          "query",
                          "onSearchQuery",
                          false
                        ],
                        [
                          "select",
                          "onSearchSelect",
                          false
                        ],
                        [
                          "no-query",
                          "onCloseSuggestions",
                          false
                        ]
                      ]);

                      subscribe_tag({
                          to: document,
                          __events: [
                            "on",
                            "click"
                          ]
                        }, out, __component, "8", [
                        [
                          "click",
                          "onCloseSuggestions",
                          false
                        ]
                      ]);
                    }
                  },
                {
                    qs: "d-none",
                    hs: "col-2",
                    fs: "col-3"
                  }
              ]
          }, out, __component, "4");

        out.ee();

        out.be("section", marko_attrs2, "10", component);

        out.be("div", marko_attrs3, "11", component);

        out.be("div", marko_attrs4, "12", component);

        out.n(marko_node0, component);

        out.be("div", marko_attrs5, "14", component);

        marko_forOf(Types, function(name, index) {
          var $keyValue$0 = "@" + index,
              $keyScope$0 = "[" + ($keyValue$0 + "]");

          out.be("button", {
              "class": marko_classValue(marko_classValue([
                "btn m-25 round",
                state.activeCategories.includes(name) ? "btn-white" : "btn-outline-white"
              ]))
            }, $keyValue$0, component, null, 1, {
              onclick: __component.d("click", "onFilter", false, [
                  index
                ])
            });

          Locale_tag({
              text: name.toCapitalCase()
            }, out, __component, "15" + $keyScope$0);

          out.ee();
        });

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.be("div", marko_attrs6, "16", component);

        Featured_tag({
            installing: state.installing,
            uninstalling: state.uninstalling
          }, out, __component, "17", [
          [
            "open",
            "onOpen",
            false
          ]
        ]);

        SortingList_tag({
            type: "application"
          }, out, __component, "18", [
          [
            "open",
            "onOpen",
            false
          ],
          [
            "install",
            "onInstall",
            false
          ],
          [
            "uninstall",
            "onUninstall",
            false
          ]
        ]);

        SortingList_tag({
            type: "plugin"
          }, out, __component, "19", [
          [
            "open",
            "onOpen",
            false
          ],
          [
            "install",
            "onInstall",
            false
          ],
          [
            "uninstall",
            "onUninstall",
            false
          ]
        ]);

        Installed_tag({}, out, __component, "20", [
          [
            "run",
            "onRun",
            false
          ]
        ]);

        out.ee();
      }
    }, out, __component, "2");

  if (state.showModal) {
    Modal_tag({
        renderBody: function(out) {
          Switch_tag({
              by: state.showModal.type,
              case: [
                  {
                      is: "open-app",
                      renderBody: function(out) {
                        ViewApp_tag({
                            item: state.showModal.dataset,
                            installing: state.installing,
                            uninstalling: state.uninstalling
                          }, out, __component, "24", [
                          [
                            "run",
                            "onRun",
                            false
                          ],
                          [
                            "open",
                            "onOpen",
                            false
                          ],
                          [
                            "install",
                            "onInstall",
                            false
                          ],
                          [
                            "uninstall",
                            "onUninstall",
                            false
                          ]
                        ]);
                      }
                    }
                ]
            }, out, __component, "22");
        }
      }, out, __component, "21", [
      [
        "dismiss",
        "onDismiss",
        false
      ]
    ]);
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
